/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User change password request
 */
export interface UserChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}
